export default "__VITE_ASSET__1Yp5nJYM__"